import React, { useState , useEffect} from 'react'
import { Table, Typography } from 'antd';
import { getCashflow } from '../../../../../api/EmiPayments';
import { useSelector } from 'react-redux';
import { CURRENCY } from '../../../../../utils/ConstantData';
import { CurrencyFormatWithDecimal } from '../../../../../helper/CurrencyFormate';
import { TabsEnum } from '../../../../../utils/Enum/ReportTabsEnum';
import ZCard from '../../../../Card/Index';
import styles from '../../../UPITxnAnalysis/upiTxnAnalysis.module.scss'

const { Text } = Typography;

const Cashflow = () => {
    const [cashFlow, setCashflow] = useState(null);
    const [quarterly, setQuarterly] = useState(null);
    const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);
    const monthlyColumns = [
        {
          title: 'Month',
          dataIndex: 'month',
          key: 'month',
          width: 180,
          render: (value, record, index) => (
            <Typography.Text style={index >= (cashFlow?.length - 4) ? { fontWeight: 'bold' } : {}}>
              {value}
            </Typography.Text>
          ),
        },
        {
          title: `Inflow (${CURRENCY})`,
          dataIndex: 'inflow',
          key: 'inflow',
          align: 'right',
          width: 150,
            align: 'right',
            className: 'no-wrap-column',
            render: (value, record, index) => (
              <Typography.Text style={index >= (cashFlow?.length - 4) ? { fontWeight: 'bold' } : {}} {...(value < 0 ? { type: "danger" } : {})}>
                {CurrencyFormatWithDecimal(value, null, CURRENCY)}
              </Typography.Text>
            ),
        },
        {
          title: `Outflow (${CURRENCY})`,
          dataIndex: 'outflow',
          key: 'outflow',
          width: 150,
          align: 'right',
          className: 'no-wrap-column',
          render: (value, record, index) => (
            <Typography.Text style={index >= (cashFlow?.length - 4) ? { fontWeight: 'bold' } : {}} {...(value < 0 ? { type: "danger" } : {})}>
              {CurrencyFormatWithDecimal(value, null, CURRENCY)}
            </Typography.Text>
              ),
        },
        {
          title: `Net Cash Flow (${CURRENCY})`,
          dataIndex: 'netCashFlow',
          key: 'netCashFlow',
          width: 150,
          align: 'right',
          className: 'no-wrap-column',
          render: (value, record, index) => (
            <Typography.Text style={index >= (cashFlow?.length - 4) ? { fontWeight: 'bold' } : {}} {...(value < 0 ? { type: "danger" } : {})}>
              {CurrencyFormatWithDecimal(value, null, CURRENCY)}
            </Typography.Text>
            ),
        },
        {
          title: `Monthly Avg Balance (${CURRENCY})`,
          dataIndex: 'avgDailyBalance',
          key: 'avgDailyBalance',
          width: 150,
            align: 'right',
            className: 'no-wrap-column',
            render: (value, record, index) => (
              <Typography.Text style={index >= (cashFlow?.length - 4) ? { fontWeight: 'bold' } : {}} {...(value < 0 ? { type: "danger" } : {})}>
                {CurrencyFormatWithDecimal(value, null, CURRENCY)}
              </Typography.Text>
            ),
        },
        {
          title: 'Inflow Transaction count',
          dataIndex: 'inflowTransactionCount',
          key: 'inflowTransactionCount',
          align: 'center',
          width: 150,
            render: (value, record, index) => (
              <Typography.Text style={index >= (cashFlow?.length - 4) ? { fontWeight: 'bold' } : {}}>
                {value}
              </Typography.Text>
            ),
        },
        {
          title: 'Outflow Transaction count',
          dataIndex: 'outflowTransactionCount',
          key: 'outflowTransactionCount',
          align: 'center',
          width: 150,
            render: (value, record, index) => (
              <Typography.Text style={index >= (cashFlow?.length - 4) ? { fontWeight: 'bold' } : {}}>
                {value}
              </Typography.Text>
            ),
        },
      ];
      

      useEffect(() => {

        const fetchData = async (accountId) => {
          try {
            console.log(selectedAccountId, 'id')

            let aggregate = accountId !== 'all'? false : true;
            let account_id = accountId !== 'all'? accountId : reportDetails?.report?.reportId;
            const response = await getCashflow(account_id, aggregate);
    
            setCashflow(response.monthly);
            setQuarterly(response.quarterly);
    
          } catch (error) {
    
            console.log("ERROR", error);
          }
        }
    
        if (selectedAccountId) {
          fetchData(selectedAccountId);
        }
      }, [selectedAccountId]);
      
  return (
    <div>
    <ZCard style={{marginBottom: '16px'}}>
    <Table
    dataSource={cashFlow}
    columns={monthlyColumns}
    pagination={false}
    scroll={{x: 1200}}
   />
  </ZCard>

  <ZCard >
    <ZCard.Title>Cumulative Quarterly Summary</ZCard.Title>
  <Table
    dataSource={quarterly}
    columns={monthlyColumns}
    pagination={false}
    showHeader={false}
    scroll={{x: 1200}}
  />
  </ZCard>
  </div>
);}

export default Cashflow;